<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="150px">
            <el-form-item label="报告类型：" prop="report_type">
                <span>{{ transEnu(model.report_type, "report_type")}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="车型：" prop="email">
                <span>{{model.car_type}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="记录时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="行驶时间：" prop="show_time" v-if="model.report_type==1">
                <span>{{model.begin_time}} 至 {{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="充电时间：" prop="show_time" v-if="model.report_type==2">
                <span>{{model.begin_time}} 至 {{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="停车时间：" prop="show_time" v-if="model.report_type==3">
                <span>{{model.begin_time}} 至 {{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="用时：" prop="show_duration">
                <span>{{model.show_duration}}({{model.duration}}秒)</span>
            </el-form-item>
            <el-form-item label="起始地点：" prop="begin_address" v-if="model.report_type==1">
                <span>{{model.begin_address}}</span>
            </el-form-item>
            <el-form-item label="起始详细地点：" prop="begin_address" v-if="model.report_type==1">
                <span>{{model.begin_address_detail}}</span>
            </el-form-item>
            <el-form-item label="结束地点：" prop="end_address" v-if="model.report_type==1">
                <span>{{model.end_address}}</span>
            </el-form-item>
            <el-form-item label="结束详细地点：" prop="end_address" v-if="model.report_type==1">
                <span>{{model.end_address}}</span>
            </el-form-item>
            <el-form-item label="充电地点：" prop="begin_address" v-if="model.report_type==2">
                <span>{{model.begin_address}}</span>
            </el-form-item>
            <el-form-item label="充电详细地点：" prop="begin_address" v-if="model.report_type==2">
                <span>{{model.begin_address_detail}}</span>
            </el-form-item>
            <el-form-item label="停车地点：" prop="begin_address" v-if="model.report_type==3">
                <span>{{model.begin_address}}</span>
            </el-form-item>
            <el-form-item label="停车详细地点：" prop="begin_address" v-if="model.report_type==3">
                <span>{{model.begin_address_detail}}</span>
            </el-form-item>
            <el-form-item label="起始经\纬度：" prop="begin_lng" v-if="model.report_type==1">
                <span>{{model.begin_lng}} | {{model.begin_lat}}</span>
            </el-form-item>
            <el-form-item label="结束经\纬度：" prop="end_lng" v-if="model.report_type==1">
                <span>{{model.end_lng}} | {{model.end_lat}}</span>
            </el-form-item>
            <el-form-item label="充电经\纬度：" prop="begin_lng" v-if="model.report_type==2">
                <span>{{model.begin_lng}} | {{model.begin_lat}}</span>
            </el-form-item>
            <el-form-item label="停车经\纬度：" prop="begin_lng" v-if="model.report_type==3">
                <span>{{model.begin_lng}} | {{model.begin_lat}}</span>
            </el-form-item>
            <el-form-item label="起始、结束电量：" prop="begin_soc">
                <span>{{model.begin_soc}}% → {{model.end_soc}}%</span>
            </el-form-item>
            <el-form-item label="行驶里程：" prop="mileage" v-if="model.report_type==1">
                <span>{{model.mileage}}km（{{model.begin_odometer}}km → {{model.end_odometer}}km）</span>
            </el-form-item>
            <el-form-item label="剩余里程：" prop="begin_mileage">
                <span>{{model.begin_mileage}}km → {{model.end_mileage}}km</span>
            </el-form-item>
            <el-form-item label="消耗电量：" prop="charge_in" v-if="model.report_type==1">
                <span>{{model.charge_in}}度</span>
            </el-form-item>
            <el-form-item label="充电方式：" prop="conn_charge_cable" v-if="model.report_type==2">
                <span>{{ transEnu(model.conn_charge_cable, "conn_charge_cable")}}</span>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in" v-if="model.report_type==2">
                <span>{{model.charge_in}}度</span>
            </el-form-item>
            <el-form-item label="使用电量：" prop="charge_use" v-if="model.report_type==2">
                <span>{{model.charge_use}}度</span>
            </el-form-item>
            <el-form-item label="消耗电量：" prop="charge_use" v-if="model.report_type==3">
                <span>{{model.charge_use}}度</span>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed">
                <span>{{model.avg_speed}}km/h</span>
            </el-form-item>
            <el-form-item label="平均功率：" prop="avg_power">
                <span>{{model.avg_power}}kw</span>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc" v-if="model.report_type==1">
                <span>{{model.avg_enc}}wh/km</span>
            </el-form-item>
            <el-form-item label="平均海拔：" prop="avg_altitude" v-if="model.report_type==1">
                <span>{{model.avg_altitude}}m</span>
            </el-form-item>
            <el-form-item label="平均车内温度：" prop="avg_inside_temp" v-if="model.report_type==1 || model.report_type==2">
                <span>{{model.avg_inside_temp}}℃</span>
            </el-form-item>
            <el-form-item label="平均车外温度：" prop="avg_outside_temp" v-if="model.report_type==1 || model.report_type==2">
                <span>{{model.avg_outside_temp}}℃</span>
            </el-form-item>
            <el-form-item label="电价：" prop="price">
                <span>{{model.price}}元/度</span>
            </el-form-item>
            <el-form-item label="预估电费：" prop="fee">
                <span>{{model.fee}}元</span>
            </el-form-item>
            <el-form-item label="是否已读：" prop="is_read">
                <span>{{ transEnu(model.is_read, "is_read")}}</span>
            </el-form-item>
            <el-form-item label="读取方式：" prop="read_type">
                <span>{{ transEnu(model.read_type, "read_type")}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelByData } from '@/api/common'

export default {
    name: 'carReportInfo',
    mixins: [editutil],
    props: {
        data_month: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data() {
        return {
            model: {
                car_id: '',
                vehicle_id: '',
                report_type: '',
                create_time: '',
                begin_time: '',
                end_time: '',
                duration: '',
                begin_lon: '',
                begin_lat: '',
                end_lon: '',
                end_lat: '',
                begin_soc: '',
                end_soc: '',
                begin_odometer: '',
                end_odometer: '',
                begin_mileage: '',
                end_mileage: '',
                charge_in: '',
                charge_use: '',
                avg_speed: '',
                avg_power: '',
                avg_enc: '',
                avg_altitude: '',
                avg_inside_temp: '',
                avg_outside_temp: '',
            },
            getObj:{
                url:'/api/admin/carreport/info',
                data:{
                    id:'',
                    month:''
                }
            },
            enu_name: ['report_type', 'is_read', 'read_type', 'conn_charge_cable'],
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data['id'] = this.id;
                this.getObj.data['month'] = this.data_month
                getModelByData(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        formateData() {
            let temp_avg_enc = this.model.avg_enc*10
            this.model.avg_enc = temp_avg_enc.toFixed(2)
        },
    }
};
</script>